import LocationDto from '@/models/Locations/LocationDto';
import PositionDto from '@/models/Positions/PositionDto';
import BreakDto from '@/models/Shared/BreakDto';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import CompanyDto from '@/models/Companies/CompanyDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';

export default class NewBookingOptionsDto {
    company: CompanyDto = new CompanyDto();
    branches: BranchDto[] = [];  
    locations: LocationDto[] = [];
    agencyUsers: AgencyUserDto[] = [];
    currentAgencyUser: AgencyUserDto = new AgencyUserDto();
    breaks: BreakDto[] = [];

}


